import { render, staticRenderFns } from "./ClaimSummary.vue?vue&type=template&id=6a171606&"
import script from "./ClaimSummary.vue?vue&type=script&lang=js&"
export * from "./ClaimSummary.vue?vue&type=script&lang=js&"
import style0 from "./ClaimSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimSummary.vue"
export default component.exports